import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const MusicFrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 208.332031 364.492188 C 208.332031 352.988281 217.660156 343.664062 229.167969 343.664062 L 786.457031 343.664062 C 797.964844 343.664062 807.292969 352.988281 807.292969 364.492188 L 807.292969 1048.738281 C 807.292969 1059.382812 799.269531 1068.304688 788.6875 1069.441406 L 470.902344 1103.660156 C 469.472656 1103.816406 468.027344 1103.816406 466.597656 1103.671875 L 227.09375 1079.730469 C 216.445312 1078.667969 208.332031 1069.710938 208.332031 1059.007812 Z M 208.332031 364.492188 "
        />
        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="250.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 78.05175 101.618155 C 76.74825 103.546137 74.908125 105.075019 72.73725 105.993998 L 72.736875 105.993998 C 71.320875 106.593023 69.764625 106.927982 68.14125 106.94111 L 67.8345 106.944111 L 67.8345 106.956864 L 23.406 109.106152 C 21.44475 109.20105 19.530375 108.486872 18.10725 107.132033 C 16.686375 105.777944 15.882 103.89985 15.882 101.935859 L 15.882 37.37922 C 15.882 33.156039 19.305 29.732558 23.52825 29.732558 L 72.47025 29.732558 C 76.693125 29.732558 80.117625 33.156039 80.118 37.37922 L 80.118 94.858965 C 80.118 97.354839 79.354125 99.691673 78.05175 101.618155 Z M 75.478875 98.004501 L 75.47925 98.004501 C 75.886875 97.03826 76.112625 95.981995 76.11375 94.85934 L 76.11375 37.789947 C 76.11375 35.551013 74.298 33.736684 72.05925 33.736684 L 23.938125 33.736684 C 21.700125 33.736684 19.885875 35.551013 19.885875 37.789947 L 19.885875 101.006002 C 19.885875 101.738935 20.2545 102.423856 20.867625 102.827832 C 21.481125 103.232183 22.256625 103.29895 22.930125 103.009002 L 22.9305 103.009002 L 57.692625 88.031133 L 57.693375 88.030758 C 58.02975 87.884846 58.419 87.91898 58.726875 88.12078 C 59.034375 88.323706 59.21925 88.666917 59.21925 89.035634 L 59.21925 90.414854 C 59.220375 93.556639 59.895 96.127157 60.93825 98.088897 C 61.98375 100.052888 63.390375 101.405851 64.899 102.172918 L 64.899375 102.174044 C 65.9085 102.684921 66.963375 102.939985 68.031375 102.94111 L 68.03175 102.94111 C 69.712875 102.939985 71.256375 102.435109 72.5475 101.56189 C 73.838625 100.690923 74.86725 99.451613 75.478875 98.004501 Z M 55.486125 95.674044 L 55.486125 99.975994 C 55.0995 99.897974 54.6795 99.893473 54.253875 99.974869 C 52.88475 100.237059 51.807375 101.349962 52.044375 102.576894 C 52.282125 103.803076 53.695875 104.43811 55.065375 104.175169 C 56.17425 103.962116 57.073875 103.204051 57.265125 102.273068 L 57.309375 102.273068 L 57.309375 92.649287 L 56.961375 92.693173 L 48.434625 93.767067 L 48.163875 93.8012 L 48.163875 101.049887 C 47.77725 100.971868 47.35725 100.966992 46.93125 101.049137 C 45.5625 101.312078 44.485125 102.423856 44.7225 103.651163 C 44.959875 104.878095 46.373625 105.512003 47.74275 105.249062 C 48.852375 105.037134 49.751625 104.277944 49.943625 103.346962 L 49.987125 103.346962 L 49.987125 96.497749 Z M 55.486125 95.674044 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />
      </g>
    </svg>
  );
};
